// extracted by mini-css-extract-plugin
export var container = "style-module--container--b05fb";
export var form = "style-module--form--47f98";
export var giftBlock = "style-module--gift-block--9c5da";
export var info = "style-module--info--4b992";
export var inner = "style-module--inner--658d4";
export var reg = "style-module--reg--d1e76";
export var screen1 = "style-module--screen1--ea1c2";
export var sub = "style-module--sub--485df";
export var type = "style-module--type--1352f";